// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__F4Lo6","buttonContainer":"styles_buttonContainer__rgexF","button":"styles_button__N2m13","titleClassName":"styles_titleClassName__GJzWu"};